import webApi from 'helpers/web-api';

import filterCallback from './filterCallback';
import validationSchema from './schema';
import * as Types from './types';

export const hideAlert = () => ({
  type: Types.HIDE_ALERT
});

export const getData = () => ({
  type: Types.REQUEST_FOR_ALERT,
  filterCallback,
  validationSchema,
  successType: Types.GET_ALERT_SUCCESS,
  errorType: Types.GET_ALERT_ERROR,
  payload: webApi({
    method: 'get',
    cache: false,
    api: 'dxp',
    action: 'getAlert'
  })
});
